import store from '@/states/index.js'

import HelperTraining from '../HelperTraining.vue'

export default [
    {
        path: '/helper_training',
        component: HelperTraining,
        name: 'helper_training',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]